import request from '@/utils/request';
// 明细查询
// 导出
export function surfaceRecycleExportApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/waybill/recovery/exportOrdersInfo',
    method: 'post',
    data,
    responseType: 'blob'
  });
}
// 详细列表
export function surfaceRecycleCollectDetailApi(data) {
 return request({
   baseURL: '/steward/web/',
   url: '/waybill/recovery/getAllOrders',
   method: 'post',
   data
 });
}
// 平台回收明细查询
export function platQueryOrderApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/recycleOrder/queryOrder',
    method: 'post',
    data
  })
}
// 面单类型
export function surfaceRecycleTypeApi(data) {
  return request({
    baseURL: '/steward/web/',
    url: '/waybill/recovery/getAllMaterial',
    method: 'post',
    data
  });
}
